import { service } from "../server/request";


export const getSchoolList=async(role_caterer,curr_date)=>{
    try{      
        let url=`mealManage/login/0?loginModule=${role_caterer}&currentDate=${curr_date}`;
       
       const resp= await service({
            method:'GET',
            url:url
        });
        if(resp.status===200){
            return {success:true,data:resp.data};
        }
    }catch(ex){
        return {error:true,errorMessage:ex.errorMessage}
    }
}

export const getAllInventorySiteListData = async(req) => {
    const {catererId}=req
    try{      
        let url=`mealManage/sites?catererId=${catererId}`;
        console.log("URL::::",url);
       
       const resp= await service({
            method:'GET',
            url:url
        });
        if(resp.status===200){
            return {success:true,data:resp.data};
        }
    }catch(ex){
        return {error:true,errorMessage:ex.errorMessage}
    }
}

export const saveInventoySiteData = async (catererID,reqBody) => {
    const url = `mealManage/createSite/${catererID}`;
    try {
        const resp = await service({
            method: 'POST',
            url: url,
            data: reqBody
        });
        if (resp.status === 200) {
            return { success: true, data: resp.data };
        } else {
            return { error: true, errorMessage: resp.data };
        }
    } catch (ex) {
        return { error: true, errorMessage: ex.errorMessage };
    }
}

export const deleteInventorySiteBysiteId = async (catererID, siteId) => {
    try {
        const url = `/mealManage/deleteSite/${catererID}/${siteId}`
        const resp = await service({
            method: 'DELETE',
            url: url
        });
        if (resp.status === 200) {
            return { success: true, data: resp.data };
        }
    } catch (ex) {
        return { error: true, errorMessage: ex.statusMessage }
    }
}

export const updateSiteList = async (recData, catererID, siteId) => {
    try {
      const url = `mealManage/updateSite/${catererID}/${siteId}`;
      const resp = await service({
        method: "PUT",
        url: url,
        data: recData,
      });
      if (resp.status === 200) {
        return { success: true, data: resp.data };
      }
    } catch (ex) {
      throw { error: true, errorMessage: ex.errorMessage || ex.message };
    }
  };

  export const getInventorySiteListDataByID = async(req) => {
    const {siteId, catererId}=req
    try{      
        let url=`mealManage/bySiteId/${siteId}?catererId=${catererId}`;
        console.log("URL::::",url);
       
       const resp= await service({
            method:'GET',
            url:url
        });
        if(resp.status===200){
            return {success:true,data:resp.data};
        }
    }catch(ex){
        return {error:true,errorMessage:ex.errorMessage}
    }
}
